import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import withCardBorderWidth from '../../hoc/with-card-border-width';
import withCardBackgroundColor from '../../hoc/with-card-background-color';
import styles from './menu.scss';

const Menu = ({ children, cardBackgroundColor, borderWidth }) => {
  const wrapperStyle = { backgroundColor: cardBackgroundColor, borderWidth };
  return (
    <div className={styles.overflow}>
      <div
        className={classNames(styles.wrapper, 'default-forum-card-background-color', 'forum-card-border-color')}
        style={wrapperStyle}
      >
        <div className={classNames(styles.container, 'menu')} style={{ marginBottom: -borderWidth }}>
          {children}
        </div>
      </div>
    </div>
  );
};

Menu.propTypes = {
  children: PropTypes.node,
  cardBackgroundColor: PropTypes.string.isRequired,
  borderWidth: PropTypes.number.isRequired,
};

export default _.flowRight(withCardBorderWidth, withCardBackgroundColor)(Menu);



// WEBPACK FOOTER //
// ./app/components/menu/menu.js